export const SET_CURRENT_CLIENTS = 'SET_CURRENT_CLIENTS';

export const actionSetCurrentClients = clients => ({
    type: SET_CURRENT_CLIENTS,
    payload: clients
})
